function assertLevelListener(listener) {
  if (typeof listener !== "function") {
    throw new Error("Battery.addLevelListener: listener must be a function");
  }
}
function assertStateListener(listener) {
  if (typeof listener !== "function") {
    throw new Error("Battery.addStateListener: listener must be a function");
  }
}
function assertLowPowerModeListener(listener) {
  if (typeof listener !== "function") {
    throw new Error("Battery.addLowPowerModeListener: listener must be a function");
  }
}
export {
  assertLevelListener,
  assertLowPowerModeListener,
  assertStateListener
};
//# sourceMappingURL=validate.js.map
